<template>
  <div class="container-fluid">
    <h1>
      404. Такой страницы не существует
    </h1>
  </div>
</template>

<script>
export default {
  // components: {
  //   gRecaptcha
  // },
  props: {},
  data() {
    return {

    }
  },
  beforeMount() {
    this.$router.push({ path: 'auth' })
  }
}
</script>